export enum BFPaymentTypes {
  PACS_008_US_DOMESTIC = 'pacs_008-us-domestic',
  PACS_008_US_INTERNATIONAL = 'pacs_008-us-international',
  PACS_008_US_INTERNATIONAL_FX = 'pacs_008-us-international-fx'
}
